import { Checkbox } from 'antd';
import { FolderOutlined } from '@ant-design/icons';
import styles from './index.module.scss';

const MaterialCard = (props) => {
    const { item, selected, batchMode, onSelect } = props;

    return (
        <div className={`${styles.MaterialCard} ${selected ? styles.selected : ''}`}>
            {batchMode && (
                <Checkbox
                    className={styles.checkbox}
                    checked={selected}
                    onChange={() => onSelect(item.id)}
                />
            )}
            <div className={styles.imageWrap}>
                {item.url ? (
                    <img src={item.url} alt={item.name} />
                ) : (
                    <div className={styles.placeholder} />
                )}
                <div className={styles.folderTag}>
                    <FolderOutlined style={{ fontSize: 12, marginRight: 4 }} />
                    <span>{item.folderName || '文件夹名...'}</span>
                </div>
            </div>
            <div className={styles.info}>
                <p className={styles.name}>{item.name}</p>
                <p className={styles.time}>{item.time}</p>
            </div>
        </div>
    );
};

export default MaterialCard;